import React from 'react';
import { Map } from 'immutable';

import type { ImmutableTrip } from 'src/types/trips/Trips';
import {
  INQUIRY_DECLINE_STATES,
  OFFER_CANCELLED_STATES,
  RESERVATION_CANCELLED_STATES,
} from '../../constants';
import Card from '../presentation/Card';
import TripDetailComment from '../TripDetailComment';

type DeclineMessagesProps = {
  trip: ImmutableTrip;
};

const DeclineMessages: React.FC<DeclineMessagesProps> = ({ trip }) => {
  const tripState = trip.getIn(['state', 'state']);
  const cancelReason = trip.get('cancel_reason');

  const inquiryDeclineMessage = trip.get('decline_message') || Map();
  const inquiryDeclineMessageContent = cancelReason && inquiryDeclineMessage.get('content')
    ? `${cancelReason}: ${inquiryDeclineMessage.get('content')}`
    : inquiryDeclineMessage.get('content') || '';
  const showInquiryDeclineMessage = inquiryDeclineMessageContent
    && INQUIRY_DECLINE_STATES.includes(tripState);

  const offerCancelMessage = trip.get('cancel_message') || Map();
  const offerCancelMessageContent = cancelReason && offerCancelMessage.get('content')
    ? `${cancelReason}: ${offerCancelMessage.get('content')}`
    : offerCancelMessage.get('content') || '';
  const showOfferCancelMessage = offerCancelMessageContent
    && OFFER_CANCELLED_STATES.includes(tripState);

  const reservationCancelMessage = trip.get('reservation_cancel_message') || Map();
  const reservationCancelMessageContent = cancelReason && reservationCancelMessage.get('content')
    ? `${cancelReason}: ${reservationCancelMessage.get('content')}`
    : reservationCancelMessage.get('content') || '';
  const showReservationCancelMessage = reservationCancelMessageContent
    && RESERVATION_CANCELLED_STATES.includes(tripState);

  return (
    <>
      {showInquiryDeclineMessage && (
        <Card>
          <TripDetailComment
            user={trip.get('owner')}
          >
            {inquiryDeclineMessageContent}
          </TripDetailComment>
        </Card>
      )}
      {showOfferCancelMessage && (
        <Card>
          <TripDetailComment
            user={trip.get('owner')}
          >
            {offerCancelMessageContent}
          </TripDetailComment>
        </Card>
      )}
      {showReservationCancelMessage && (
        <Card>
          <TripDetailComment
            user={reservationCancelMessage.get('user')}
          >
            {reservationCancelMessageContent}
          </TripDetailComment>
        </Card>
      )}
    </>
  );
};

export default DeclineMessages;
